import {createApp} from "vue";
import App from "@/vue/WallBuilder/WallBuilder.vue";

// App main
const main = async () => {
    // Async load the vue module
    const app = createApp(App)
    app.mount('#wall-builder-app')
};

// Execute async function
main().then(() => {
    console.log('Loaded wall builder 12-19-24');
});

// Accept HMR as per: https://vitejs.dev/guide/api-hmr.html
if (import.meta.hot) {
    import.meta.hot.accept(() => {
        console.log("HMR")
    });
}
